import { render, staticRenderFns } from "./DeleteUser.vue?vue&type=template&id=66f5b8ff&scoped=true&lang=html&"
import script from "./DeleteUser.vue?vue&type=script&lang=js&"
export * from "./DeleteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f5b8ff",
  null
  
)

export default component.exports